import type { WorkspaceContentFragment } from "gql-types/documents/web-client";
import { Icon, MessageStripe, Stack, Text } from "prism-react";
import React from "react";

import { paths } from "utils/router";

const SPENDING_LIMIT_WARNING = 0.9; // 90% of the included + ondemand credits used

export const CloseToSpendingLimit: React.FC<{
  workspace: WorkspaceContentFragment;
  isAdmin: boolean;
}> = ({ workspace, isAdmin }) => {
  const { featureFlags, limits, usage } = workspace;

  const onDemandCreditLimit = limits.onDemandCreditLimit ?? 0;

  const isCloseToSpendingLimit =
    featureFlags.ubbBeta &&
    !featureFlags.friendOfCsb &&
    usage.credits / (limits.includedCredits + onDemandCreditLimit) >
      SPENDING_LIMIT_WARNING;

  if (!isCloseToSpendingLimit) {
    return null;
  }

  return (
    <MessageStripe corners="straight" variant="warning">
      <Stack gap={2} horizontal>
        <Icon type="circleBang" />
        <Text>
          <Text weight="medium">
            Your workspace is close to hitting its spending limit.
          </Text>{" "}
          {isAdmin
            ? "To keep using CodeSandbox, increase your spending limit."
            : "To keep using CodeSandbox, ask an administrator to increase your spending limit."}
        </Text>
      </Stack>
      {isAdmin && (
        <MessageStripe.Action
          as="a"
          href={paths.dashboard.workspaceSettings(workspace.id)}
        >
          Change spending limit
        </MessageStripe.Action>
      )}
    </MessageStripe>
  );
};
